import { render, staticRenderFns } from "./PopupBannerShow.vue?vue&type=template&id=67cb9fe3&"
import script from "./PopupBannerShow.vue?vue&type=script&lang=js&"
export * from "./PopupBannerShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports